import { useEffect, useMemo, useState } from 'react'
import { useControlField } from 'remix-validated-form'
import { SelectMultipleField } from '~/components'
import { toast } from '~/components/ui'
import {
  HOSPITALITY_SUBTYPES,
  INDUSTRIAL_SUBTYPES,
  LAND_SUBTYPES,
  MULTIFAMILY_SUBTYPES,
  OFFICE_SUBTYPES,
  OTHER_SUBTYPES,
  PROPERTY_TYPES,
  RETAIL_SUBTYPES,
  cn,
} from '~/utils'

export default function PropertyTypesField({
  className,
  includeSubtypes = true,
  required = true,
}: {
  className?: string
  includeSubtypes?: boolean
  required?: boolean
}) {
  const [propertyTypes] = useControlField<string[]>('propertyTypes')
  const [_, setPropertySubTypes] = useControlField<string[]>('propertySubtypes')
  const [hasWarningShown, setHasWarningShown] = useState(false)

  const groups = useMemo(() => {
    const groups: { [group: string]: string[] } = {}
    if (propertyTypes.includes('Hospitality')) {
      groups['Hospitality'] = HOSPITALITY_SUBTYPES
    }
    if (propertyTypes.includes('Industrial')) {
      groups['Industrial'] = INDUSTRIAL_SUBTYPES
    }
    if (propertyTypes.includes('Land')) {
      groups['Land'] = LAND_SUBTYPES
    }
    if (propertyTypes.includes('Multifamily')) {
      groups['Multifamily'] = MULTIFAMILY_SUBTYPES
    }
    if (propertyTypes.includes('Office')) {
      groups['Office'] = OFFICE_SUBTYPES
    }
    if (propertyTypes.includes('Retail')) {
      groups['Retail'] = RETAIL_SUBTYPES
    }
    if (propertyTypes.includes('Other')) {
      groups['Other'] = OTHER_SUBTYPES
    }
    return groups
  }, [propertyTypes])

  useEffect(() => {
    if (Object.keys(groups).length === 0) {
      setPropertySubTypes([])
    }
  }, [groups, setPropertySubTypes])

  useEffect(() => {
    if (propertyTypes.length > 2 && !hasWarningShown) {
      setTimeout(() => {
        toast({
          variant: 'destructive',
          title: 'Primary Use Limit Exceeded',
          description:
            'Please select a maximum of two primary uses. You can select multiple secondary uses instead.',
          duration: 10000,
        })
      }, 500)
      setHasWarningShown(true)
    }
  }, [propertyTypes, hasWarningShown])

  return (
    <>
      <SelectMultipleField
        required={required}
        className={cn(className, 'col-span-6')}
        label="Primary Use"
        name="propertyTypes"
        limitSelectionNumber={2}
        options={PROPERTY_TYPES}
      />
      {includeSubtypes && Object.keys(groups).length > 0 && (
        <SelectMultipleField
          required={false}
          className="col-span-6"
          label="Secondary Use"
          name="propertySubtypes"
          options={groups}
        />
      )}
    </>
  )
}
